/* eslint-disable no-continue */
import { BOX_CONDITIONS, SHOE_CONDITIONS } from 'shared/enums/ConditionsEnums';

/*
  [getNewAvailableSizes]
  returns an array of variants with 1 variant per size prioritized by:
  1. shoeCondition: new_no_defects & boxCondition: good_condition
  2. shoeCondition: new_no_defects & boxCondition: NOT good_condition (first lowest priced)
  3. shoeCondition: new_with_defects & boxCondition: any (first lowest priced)
*/
export const getNewAvailableSizes = (productVariants) => {
  if (!productVariants) return;
  const map = new Map();

  for (const variant of productVariants) {
    if (variant.stockStatus === 'not_in_stock') continue;
    if (
      ![SHOE_CONDITIONS.NEW_NO_DEFECTS, SHOE_CONDITIONS.NEW_WITH_DEFECTS].includes(
        variant.shoeCondition,
      )
    ) {
      continue;
    }

    if (map.has(variant?.sizeOption?.value)) {
      const previousVariant = map.get(variant?.sizeOption?.value);
      const currentVariantLowestPrice = variant.lowestPriceCents?.amount;
      const previousLowestPrice = previousVariant.lowestPriceCents?.amount;

      // if previous variant is shoeCondition: new_no_defects & boxCondition: good_condition, do not do replace
      if (
        previousVariant.shoeCondition === SHOE_CONDITIONS.NEW_NO_DEFECTS &&
        previousVariant.boxCondition === BOX_CONDITIONS.GOOD_CONDITION
      ) {
        continue;
      }

      // previous variant is NOT shoeCondition: new_no_defects & boxCondition: good_condition
      // and current variant IS shoeCondition: new_no_defects & boxCondition: good_condition
      // replace previous variant with current
      if (
        variant.shoeCondition === SHOE_CONDITIONS.NEW_NO_DEFECTS &&
        variant.boxCondition === BOX_CONDITIONS.GOOD_CONDITION
      ) {
        map.set(variant?.sizeOption?.value, variant);
        continue;
      }

      // previous variant is NOT shoeCondition: new_no_defects & boxCondition: good_condition
      // and current variant is NOT shoeCondition: new_no_defects & boxCondition: good_condition
      // but current variant is shoeCondition: new_no_defects, get lowest price regardless of boxCondition
      if (variant.shoeCondition === SHOE_CONDITIONS.NEW_NO_DEFECTS) {
        // if previousVariant was shoeCondition: new_with_defects, replace with current variant that is shoeCondition: new_no_defects
        if (previousVariant.shoeCondition === SHOE_CONDITIONS.NEW_WITH_DEFECTS) {
          map.set(variant?.sizeOption?.value, variant);
          continue;
        }

        // if previousVariant was also shoeCondition: new_no_defects, replace with current variant if current price is lower
        if (currentVariantLowestPrice < previousLowestPrice) {
          map.set(variant?.sizeOption?.value, variant);
          continue;
        }
      }

      // for shoeCondition: new_with_defects, just get the lowest price options, regardless of boxCondition
      if (currentVariantLowestPrice < previousLowestPrice) {
        map.set(variant?.sizeOption?.value, variant);
      }
    } else {
      // if the current variant's size does not exist in the map already, set it in the map
      map.set(variant?.sizeOption?.value, variant);
    }
  }

  return [...map.values()];
};
